export default __webpack_public_path__ + "static/media/Food-Vally.ca896c36.png";